<app-modal
  #unFavModal
  [modalMessage]="app.text.thread.unFavCaseMessage"
  [modalTitle]="app.text.thread.modalTitle"
  (ok)="setFav(false)"
  >
</app-modal>
<div class="card mx-1 mb-3 mt-1" style="cursor: pointer">
  <!-- <a [routerLink]="app.thread.getRouterURL(doc._id)"> -->
  <div class="card-header p-0 m-0" [ngClass]="headerColor">
    @if (model !== null) {
      <span
        class="btn btn-sm thread-detail status ms-3"
        [ngClass]="getStatusStyle(model[app.fieldId.thread.omfStatus])"
        >
        Status:&nbsp;
        {{
        app.field.getFieldValueAsText(
        app.fieldId.thread.omfStatus,
        model["thread.omfStatus"]
        )
        }}
        &nbsp;
        @if (model[app.fieldId.thread.omfStatus] === '120') {
          <i
            class="fa fa-lock"
          ></i>
        }
      </span>
    }
    <span class="float-end">
      <button class="btn btn-sm">
        <i class="fas fa-comment icon" [ngClass]="iconColor"></i>&nbsp;
        @if (commentCount > 0) {
          <span
            class="thread-detail"
            [ngClass]="textColor"
            >{{ commentCount }}&nbsp;{{ app.text.thread.comment }}</span
            >
          }
          @if (commentCount == 0) {
            <span
              class="thread-detail"
              [ngClass]="textColor"
              >
              0&nbsp;{{ app.text.thread.comment }}</span
              >
            }
          </button>
          @if (app.permission.post.hasTasks) {
            <button class="btn btn-sm">
              <i
                class="fas fa-tasks icon"
          [ngClass]="{
            'green-icon': completedTasksCount === taskCount && taskCount > 0
          }"
                ></i
                >&nbsp;
                @if (taskCount > 0) {
                  <span class="thread-detail">
                    {{ completedTasksCount | json }} / {{ taskCount | json }}&nbsp;{{
                    app.text.thread.task
                    }}</span
                    >
                  }
                  @if (taskCount == 0) {
                    <span class="thread-detail">
                      0&nbsp;{{ app.text.thread.task }}</span
                      >
                    }
                  </button>
                }
                <button class="btn btn-sm">
                  <i
                    class="fas fa-lightbulb icon"
                    [ngClass]="{ 'green-icon': finalSolution !== '' }"
                    ></i
                    >&nbsp;
                    @if (solutionCount > 0) {
                      <span
                        class="thread-detail"
                        [ngClass]="textColor"
                        >{{ solutionCount }}&nbsp;{{ app.text.thread.solution }}</span
                        >
                      }
                      @if (solutionCount == 0) {
                        <span
                          class="thread-detail"
                          [ngClass]="textColor"
                          >
                          0&nbsp;{{ app.text.thread.solution }}</span
                          >
                        }
                      </button>
                      @if (isFavorite) {
                        <button
                          class="btn btn-sm"
        (click)="
          $event.stopPropagation(); $event.preventDefault(); unFavModal.open()
        "
                          [title]="app.text.thread.unfav"
                          >
                          <i class="fas fa-star icon mx-1 px-1" [ngClass]="iconColor"></i>
                        </button>
                      }
                      @if (!isFavorite) {
                        <button
                          class="btn btn-sm"
        (click)="
          $event.stopPropagation();
          $event.preventDefault();
          app.thread.thread = model;
          setFav(true)
        "
                          [title]="app.text.thread.fav"
                          >
                          <i class="far fa-star icon mx-1 px-1" [ngClass]="iconColor"></i>
                        </button>
                      }
                    </span>
                  </div>
                  <!-- (click)="app.routing.navigateThread(doc._id)" -->
                  <div class="row col-no-mg card-content">
                    <div class="col-md-4" [ngStyle]="{ 'background-color': '#ffffff' }">
                      @if (model !== null) {
                        <div class="btn btn-sm card-title mt-1">
                          <b>{{ model["thread.title"] }}</b>
                        </div>
                      }
                      <div>
                        @if (showUploadedImage(doc)) {
                          <img
                            class="image"
                            [src]="app.file.getUrl(this.app.thread.getImage(doc._id))"
                            loading="lazy"
                            (load)="updateLoadedImageCounter()"
                            width="150px"
                            height="150px"
                            />
                        }
                        @if (
                          doc.externalImageSource !== '' && doc.externalImageSource != null
                          ) {
                          <img
                            class="image"
                            [src]="doc.externalImageSource"
                            loading="lazy"
                            (load)="updateLoadedImageCounter()"
                            width="150px"
                            height="150px"
                            />
                        }
                      </div>
                    </div>
                    <div class="col-md-8 mt-1">
                      @for (field of app.list.threadItem.featureFields; track field) {
                        <div>
                          @if (model !== null && model[field]) {
                            <div class="row app-field">
                              <div class="fieldLabel col-md-4">
                                <div class="fieldName text-md-left">
                                  {{ app.field.getLabel(field) }}
                                </div>
                              </div>
                              <div class="col-md-7">
                                <div>
                                  @switch (fieldTypes[field]) {
                                    @case ('timestamp') {
                                      <div class="fieldValue text-md-left">
                                        @if (model[field] > 0) {
                                          <span>
                                            {{ model[field] | date : "yyyy-MM-dd" : "UTC"}}
                                          </span>
                                        }
                                      </div>
                                    }
                                    @case ('user-options') {
                                      <div
                                        class="fieldValue text-md-left"
                                        >
                                        {{ app.users.getOptionName(model[field]) }}
                                      </div>
                                    }
                                    @case ('value') {
                                      <div class="fieldValue text-md-left">
                                        {{ model[field] }}
                                      </div>
                                    }
                                    @case ('typeahead') {
                                      <div class="fieldValue text-md-left">
                                        {{ model[field] }}
                                      </div>
                                    }
                                    @case ('text') {
                                      <div class="fieldValue text-md-left">
                                        <app-limit [textInput]="model[field]" limit="50"></app-limit>
                                      </div>
                                    }
                                    @case ('options') {
                                      <div class="fieldValue text-md-left" (click)="$event.stopPropagation(); $event.preventDefault()">
                                        {{ app.field.getOptionText(field, model[field]) }}
                                      </div>
                                    }
                                  }
                                </div>
                              </div>
                            </div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                <!-- </a> -->
                <div class="card-footer p-0 m-0">
                  <div class="float-end me-3">
                    <span>
                      @if (model != null) {
                        <app-credits
                          class="last-comment"
                          type="thread"
                          [inputDoc]="doc"
                          [isEdited]="true"
                        ></app-credits>
                      }
                    </span>
                    <span>
                      @if (model != null) {
                        <app-credits
                          class="last-comment credits ms-2"
                          type="thread"
                          [inputDoc]="doc"
                          [isCreated]="true"
                        ></app-credits>
                      }
                    </span>
                  </div>
                </div>
              </div>
